import { useState } from 'react';
import { Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AuthorizeSendModal } from './AuthorizeSendModal';
import { useCampaignStore } from '@/stores';

/**
 * Issue #861 — the entry point to the "authorize and send" surface for an email-channel report. A
 * self-contained trigger + modal so the (large) report detail page mounts it in one line. The report
 * stays Ready on send; "sent" is a derived lens the modal shows.
 */
export function AuthorizeSendButton({ reportId }: { reportId: string }) {
  const [open, setOpen] = useState(false);
  // The server refuses the send below Finance Manage; a view-only user gets no control to click.
  const canManage = useCampaignStore((st) => st.canManage('Finance'));
  if (!canManage) return null;
  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={() => setOpen(true)}
        data-testid="open-authorize-send"
      >
        <Send className="mr-2 h-4 w-4" />
        Send to the receiving office…
      </Button>
      <AuthorizeSendModal reportId={reportId} open={open} onOpenChange={setOpen} />
    </>
  );
}
